<template>
    <div>
	   <video-player 
	    class="video-player vjs-custom-skin" 
	    ref="videoPlayer"
		:playsinline="true"
		:options="playerOptions">
		</video-player>
	</div>
</template>

<script>
export default{
  props:{
    videoUrl:{
      type:String
    }
  },
  data(){
    return{
      playerOptions:{
        playbackRates: [0.5, 1.0, 1.5, 2.0],//倍速控制
        autoplay: false,//是否自动播放
        muted: false,//是否静音播放
        loop: false,//是否循环播放
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",//比例
        fluid: true,
        sources: [
          {
            type: "",
            src:''
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,//剩余时间是否显示
          remainingTimeDisplay: true,//剩余时间是否显示，有一个即可
          fullscreenToggle: true,//全屏按钮
        },
      }
    }
  },
  watch:{
    videoUrl:{
      handler(val){
		this.playerOptions.sources[0].src = val;
	  },
	  immediate:true
    }
  }
}
</script>

<style scoped="scoped">
.video-js .vjs-icon-placeholder {
	width: 80%;
	height: 80%;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/videoPlayer.vue